import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {Platform} from '@ionic/angular';


@Component({
  selector: 'unr-privacy',
  templateUrl: 'privacy.html',
  styleUrls: [
    'privacy.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPage {

  constructor(private statusbarService: StatusbarService,
              private platform: Platform) {
  }

  ionViewWillEnter(): void {
    if (this.platform.is('ios')) {
      this.statusbarService.changeStatusBar({ style: ''});
    } else {
      this.statusbarService.changeStatusBar({ style:'' });
    }
  }
}
